export default __webpack_public_path__ + "static/launchpad_card-99c25108e5c78cebdaf2f9f719cfcb41.png";